
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/moment_card/templates/removed_popover"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "This moment was edited very recently and no longer fits within this sorting category, or it was deleted.\n";
},"useData":true});
    }).call(this);
  